import firebase from 'firebase/app';
if (process.env.VUE_APP_FIREBASE_CONFIG) {
    firebase.initializeApp(JSON.parse(process.env.VUE_APP_FIREBASE_CONFIG));
}
